import React from "react";
import {Typography, Box} from "@mui/material";

import TagsList from "./TagsList";

export default function AssessmentStatusLabel({status, tagList}) {
    return (
      <Box>
          <Typography variant="body2" sx={{fontWeight: "bold"}}>
              {`Assessment result - ${status}`}
          </Typography>
          <Typography variant="body2" sx={{fontWeight: "bold", marginTop: "0.5rem"}}>
              Feedback
          </Typography>
          <TagsList tagList={tagList}/>
      </Box>
    );
}